module.exports = __webpack_public_path__ + "static/media/bestwestern.a66fa9a7.gif";